// extracted by mini-css-extract-plugin
export default {"thumbnailContainer":"base-list-mobile-options-module__thumbnailContainer--_FJ_D"};